import React from 'react'
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
	width: "100%",
	height: "520px",
	maxHeight: "520px",
};

const center = { lng:-73.729674,lat:-41.425823 };


function Map() {
	    		
	const options = {
		fillColor: "lightblue",
		fillOpacity: 0.2,
		strokeColor: "red",
		strokeOpacity: 1,
		strokeWeight: 2,
		clickable: true,
		draggable: false,
		editable: false,
		geodesic: false,
		color:'white',
		zIndex: 10
	  }
	
	const onLoad = () => console.log('onload!')
	const proyecto = { lng:-73.729674,lat:-41.425823 };
	return (
		<LoadScript googleMapsApiKey="AIzaSyBX-fT0cZLTKydQN_HFfeCfHKq_Um_4cSQ">
			<GoogleMap
				mapContainerStyle={containerStyle}
				center={center}
				zoom={13}
				mapTypeId={"hybrid"}
				zIndex="1"

			>
				<Marker
					label={ {text:'Reserva Los Muermos', color:'white' }}
					onLoad={onLoad}
					position={proyecto}
					options={options}
				/>
			</GoogleMap>
		</LoadScript>
	);
}
export default Map